import { connect } from 'react-redux';

import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import { getSearcherNights } from '../../store/selectors/similar-packages';

import { setNightsAction } from '../../store/actions/similar-packages';
import SearchParamsNights from '../ShortInfo/SearchParams/SearchParamsNights';

const mapStateToProps = (state) => ({
  nights: getSearcherNights(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  onChangeNights: setNightsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchParamsNights);
